import Admin from '../layouts/Admin.vue'

// Admin
import Dashboard from '../views/admin/Dashbaord.vue'
import Profile from '../views/admin/Profile.vue'
import KYC from '../views/admin/kyc.vue'
import Airtime from '../views/admin/airtime.vue'
import TransactionCalculator from '../views/admin/TransactionCalculator.vue'
import WalletFundingReq from '../views/admin/WalletFundingReq.vue'

import salesRoutes from './admin/sales.routes'
import purchaseRoutes from './admin/purchase.routes'
import messageRoutes from './admin/messages.routes'
import userRoutes from './admin/user.routes'
import giftcardRoutes from './admin/giftcard.routes'
import settingRoutes from './admin/settings.routes'
import withdrawalRoutes from './admin/withdrawal.routes'
import promoCodesRoutes from './admin/promoCodes.router'

const adminRoutes = {
  path: '/hrd12/hrd12',
  redirect: '/hrd12/hrd12/dashboard',
  component: Admin,
  children: [
    {
      path: '/hrd12/hrd12/dashboard',
      component: Dashboard,
      name: 'DashboardAdmin',
      meta: {
        title: 'Dashboard'
      }
    },
    {
      path: '/hrd12/hrd12/airtime',
      component: Airtime,
      name: 'AdminAirtime',
      meta: {
        title: 'Airtime'
      }
    },
    {
      path: '/hrd12/hrd12/profile',
      component: Profile,
      name: 'AdminProfile',
      meta: {
        title: 'Profile'
      }
    },
    {
      path: '/hrd12/hrd12/transaction-calculator',
      component: TransactionCalculator,
      name: 'TransactionCalculator',
      meta: {
        title: 'Transaction Calculator'
      }
    },
    {
      path: '/hrd12/hrd12/wallet-funding',
      component: WalletFundingReq,
      name: 'WalletFundingReq',
      meta: {
        title: 'Wallet Funding Request'
      }
    },
    {
      path: '/hrd12/hrd12/flagged-deposits',
      component: () => import('../views/admin/FlaggedDeposits.vue'),
      name: 'FlaggedDeposits',
      meta: {
        title: 'Flagged Deposits'
      }
    },
    {
      path: '/hrd12/hrd12/leaderboard',
      component: () => import('../views/admin/Leaderboards.vue'),
      name: 'AdminLeaderboard',
      meta: {
        title: 'Leaderboard'
      }
    },
    {
      path: '/hrd12/hrd12/traders-post',
      component: () => import('../views/admin/TraderPost.vue'),
      name: 'AdminTraderPost',
      meta: {
        title: 'Traders Post'
      }
    },
    {
      path: '/hrd12/hrd12/announcement',
      component: () => import('../views/admin/Announcement.vue'),
      name: 'AdminAnnouncement',
      meta: {
        title: 'Announcement'
      }
    },
    {
      path: '/hrd12/hrd12/kyc',
      component: KYC,
      name: 'AdminKYC',
      meta: {
        title: 'KYC'
      }
    },
    giftcardRoutes,
    purchaseRoutes,
    salesRoutes,
    messageRoutes,
    userRoutes,
    settingRoutes,
    withdrawalRoutes,
    promoCodesRoutes
  ]
}

export default adminRoutes
